type ChangePasswordResponse = {
  ok?: boolean;
  error?: string;
};

async function parseResponse<T>(response: Response): Promise<T> {
  const payload = (await response.json().catch(() => ({}))) as Record<string, unknown>;
  if (!response.ok) {
    const message =
      (typeof payload.error === "string" && payload.error.trim()) || `Request failed (${response.status})`;
    throw new Error(message);
  }
  return payload as T;
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  const response = await fetch("/auth/change-password", {
    method: "POST",
    headers: { "content-type": "application/json", accept: "application/json" },
    body: JSON.stringify({ currentPassword, newPassword }),
  });
  await parseResponse<ChangePasswordResponse>(response);
}
